module.exports = __webpack_public_path__ + "img/process-action.4aca161a.png";